import EmblaCarousel from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";
import { Fancybox } from "@fancyapps/ui";
import { setupSliderDots } from "./slider-dots.js";

const fancyboxOptions = {
  theme: "light",
  hideScrollbar: false,
  mainClass: "fancybox-brand",
};

const bindSliderLightbox = (slider, embla) => {
  const items = embla
    .slideNodes()
    .map((slide) => slide.querySelector("a.image-card[data-fancybox]"))
    .filter(Boolean)
    .map((link) => ({
      src: link.getAttribute("href") || "",
      caption: link.getAttribute("data-caption") || "",
    }))
    .filter((item) => item.src !== "");

  if (items.length === 0) {
    return;
  }

  slider.addEventListener(
    "click",
    (event) => {
      const link = event.target.closest("a.image-card[data-fancybox]");

      if (!link || !slider.contains(link)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const href = link.getAttribute("href") || "";
      const startIndex = items.findIndex((item) => item.src === href);

      Fancybox.show(items, {
        ...fancyboxOptions,
        startIndex: startIndex >= 0 ? startIndex : 0,
      });
    },
    true,
  );
};

const assignRevealStagger = (embla) => {
  const selected = embla.selectedScrollSnap();
  const slides = embla.slideNodes();
  const count = slides.length;

  slides.forEach((slide, index) => {
    const rawDistance = Math.abs(index - selected);
    const distance = Math.min(rawDistance, count - rawDistance);

    slide.dataset.revealIndex = String(distance + 1);
  });
};

const positionArrows = (slider, embla) => {
  const stage = slider;
  const prev = slider.querySelector("[data-image-card-slider-prev]");
  const next = slider.querySelector("[data-image-card-slider-next]");
  const selectedSlide = embla.slideNodes()[embla.selectedScrollSnap()];
  const media = selectedSlide?.querySelector(".image-card__media");

  if (!stage || !prev || !next || !media) {
    return;
  }

  const stageTop = stage.getBoundingClientRect().top;
  const mediaRect = media.getBoundingClientRect();
  const top = `${
    mediaRect.top + mediaRect.height / 2 - stageTop - prev.offsetHeight / 2
  }px`;

  prev.style.top = top;
  next.style.top = top;
};

const initImageCardSlider = (slider) => {
  const viewport = slider.querySelector(".image-card-slider__viewport");

  if (!viewport) {
    return;
  }

  const embla = EmblaCarousel(
    viewport,
    {
      align: "center",
      loop: true,
      containScroll: false,
      slidesToScroll: 1,
      duration: 35,
    },
    [
      Autoplay({
        delay: 4000,
        stopOnInteraction: true,
      }),
    ],
  );

  slider
    .querySelector("[data-image-card-slider-prev]")
    ?.addEventListener("click", () => {
      embla.scrollPrev();
    });

  slider
    .querySelector("[data-image-card-slider-next]")
    ?.addEventListener("click", () => {
      embla.scrollNext();
    });

  setupSliderDots(slider.querySelector("[data-slider-dots]"), embla, "slide");
  bindSliderLightbox(slider, embla);

  const syncArrows = () => {
    assignRevealStagger(embla);
    positionArrows(slider, embla);
  };

  const resizeObserver = new ResizeObserver(() => {
    positionArrows(slider, embla);
  });
  resizeObserver.observe(viewport);

  embla.on("select", syncArrows);
  embla.on("scroll", () => {
    positionArrows(slider, embla);
  });
  embla.on("reInit", syncArrows);

  syncArrows();
  slider.classList.add("is-ready");
};

document
  .querySelectorAll("[data-image-card-slider]")
  .forEach(initImageCardSlider);
